import { Action } from '@ngrx/store';
import { ApplicationException, AutoCompleteResult, HttpException, ServiceException } from '@uzurv/core';
import { IGeoCoords, Location, Sublocation } from '@uzurv/clara';

export enum LocationManagerActionTypes {
  Reset = '[Location Manager] Reset',
  Search = '[Location Manager] Search',
  SearchResultsLoaded = '[Location Manager] Search results loaded',
  LoadSearchResultsFailed = '[Location Manager] Load search results failed',
  ClearSearch = '[Location Manager] Clear Search',
  SearchResultSelected = '[Location Manager] Search result selected',
  LocationLoaded = '[Location Manager] Location loaded',
  LoadLocationFailed = '[Location Manager] Load location failed',
  MapLoaded = '[Location Manager] Map loaded',
  UseOffsetLocation = '[Location Manager] Use offset location',
  LocationMouseover = '[Location Manager] Location mouse over',
  LocationMouseout = '[Location Manager] Location mouse out',
  LocationSelected = '[Location Manager] Location selected',
  AddNewLocation = '[Location Manager] Add new location',
  CancelAddNewLocation = '[Location Manager] Cancel adding new location',
  MoveMap = '[Location Manager] Move map',
  SetNewLocationName = '[Location Manager] Set new location name',
  SubmitNewLocation = '[Location Manager] Submit new location',
  NewLocationInvalid = '[Location Manager] New location invalid',
  NewLocationAccepted = '[Location Manager] New location accepted',
  SubmitNewLocationFailed = '[Location Manager] Submit new location failed',
  DeleteSublocation = '[Location Manager] Delete sublocation',
  DeleteSublocationSuccess = '[Location Manager] Delete sublocation success',
  DeleteSublocationFailed = '[Location Manager] Delete sublocation failed',
  GetUserLocation = '[Location Manager] Get user location',
  GetUserLocationSuccess = '[Location Manager] Get user location success',
  GetUserLocationFailed = '[Location Manager] Get user location failed',
  GeocodeOffsetLocationSuccess = '[Location Manager] Geocode offset location success',
  GeocodeOffsetLocationFailed = '[Location Manager] Geocode offset location failed'
}

export class Reset implements Action {
  readonly type = LocationManagerActionTypes.Reset;
}

export class Search implements Action {
  readonly type = LocationManagerActionTypes.Search;
  constructor(public payload: string) {}
}

export class SearchResultsLoaded implements Action {
  readonly type = LocationManagerActionTypes.SearchResultsLoaded;
  constructor(public payload: Array<AutoCompleteResult>) {}
}

export class LoadSearchResultsFailed implements Action {
  readonly type = LocationManagerActionTypes.LoadSearchResultsFailed;
  constructor(public payload: HttpException) {}
}

export class ClearSearch implements Action {
  readonly type = LocationManagerActionTypes.ClearSearch;
}

export class SearchResultSelected implements Action {
  readonly type = LocationManagerActionTypes.SearchResultSelected;
  constructor(public payload: string) {}
}

export class LocationLoaded implements Action {
  readonly type = LocationManagerActionTypes.LocationLoaded;
  constructor(public payload: Location) {}
}

export class LoadLocationFailed implements Action {
  readonly type = LocationManagerActionTypes.LoadLocationFailed;
  constructor(public payload: HttpException) {}
}

export class MapLoaded implements Action {
  readonly type = LocationManagerActionTypes.MapLoaded;
}

export class UseOffsetLocation implements Action {
  readonly type = LocationManagerActionTypes.UseOffsetLocation;
  constructor(public payload: boolean) {}
}

export class LocationMouseover implements Action {
  readonly type = LocationManagerActionTypes.LocationMouseover;
  constructor(public payload: Location | Sublocation) {}
}

export class LocationMouseout implements Action {
  readonly type = LocationManagerActionTypes.LocationMouseout;
  constructor(public payload: Location | Sublocation) {}
}
export class LocationSelected implements Action {
  readonly type = LocationManagerActionTypes.LocationSelected;
  constructor(public payload: Location) {}
}

export class AddNewLocation implements Action {
  readonly type = LocationManagerActionTypes.AddNewLocation;
}

export class CancelAddNewLocation implements Action {
  readonly type = LocationManagerActionTypes.CancelAddNewLocation;
}

export class MoveMap implements Action {
  readonly type = LocationManagerActionTypes.MoveMap;
  constructor(public payload: IGeoCoords) {}
}

export class SetNewLocationName implements Action {
  readonly type = LocationManagerActionTypes.SetNewLocationName;
  constructor(public payload: string) {}
}

export class SubmitNewLocation implements Action {
  readonly type = LocationManagerActionTypes.SubmitNewLocation;
}

export class NewLocationInvalid implements Action {
  readonly type = LocationManagerActionTypes.NewLocationInvalid;
  constructor(public payload: ApplicationException) {}
}

export class NewLocationAccepted implements Action {
  readonly type = LocationManagerActionTypes.NewLocationAccepted;
  constructor(public payload: Sublocation) {}
}

export class SubmitNewLocationFailed implements Action {
  readonly type = LocationManagerActionTypes.SubmitNewLocationFailed;
  constructor(public payload: HttpException) {}
}

export class DeleteSublocation implements Action {
  readonly type = LocationManagerActionTypes.DeleteSublocation;
  constructor(public payload: Sublocation) {}
}

export class DeleteSublocationSuccess implements Action {
  readonly type = LocationManagerActionTypes.DeleteSublocationSuccess;
}

export class DeleteSublocationFailed implements Action {
  readonly type = LocationManagerActionTypes.DeleteSublocationFailed;
  constructor(public payload: HttpException) {}
}

export class GetUserLocation implements Action {
  readonly type = LocationManagerActionTypes.GetUserLocation;
}

export class GetUserLocationSuccess implements Action {
  readonly type = LocationManagerActionTypes.GetUserLocationSuccess;
  constructor(public payload: IGeoCoords) {}
}

export class GetUserLocationFailed implements Action {
  readonly type = LocationManagerActionTypes.GetUserLocationFailed;
  constructor(public payload: ServiceException) {}
}

export class GeocodeOffsetLocationSuccess implements Action {
  readonly type = LocationManagerActionTypes.GeocodeOffsetLocationSuccess;
  constructor(public payload: Location) {}
}

export class GeocodeOffsetLocationFailed implements Action {
  readonly type = LocationManagerActionTypes.GeocodeOffsetLocationFailed;
  constructor(public payload: ServiceException) {}
}

export type LocationManagerActions =
  | Reset
  | Search
  | SearchResultsLoaded
  | LoadSearchResultsFailed
  | ClearSearch
  | SearchResultSelected
  | LocationLoaded
  | LoadLocationFailed
  | MapLoaded
  | UseOffsetLocation
  | LocationMouseover
  | LocationMouseout
  | LocationSelected
  | AddNewLocation
  | CancelAddNewLocation
  | MoveMap
  | SetNewLocationName
  | SubmitNewLocation
  | NewLocationInvalid
  | NewLocationAccepted
  | SubmitNewLocationFailed
  | DeleteSublocation
  | DeleteSublocationSuccess
  | DeleteSublocationFailed
  | GetUserLocation
  | GetUserLocationSuccess
  | GetUserLocationFailed
  | GeocodeOffsetLocationSuccess
  | GeocodeOffsetLocationFailed;
